import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { Storages } from 'src/appConstants';
import { Authentication } from 'src/types/dto';
import useUserIdStore from './useUserIdStore';
import { encodeBase64 } from 'src/utils/base64';

export { useUserStatusSync } from './useUserStatusSync';

type UserStore = {
	id: number;
	email: string;
	name: string;
	userStatus: string;
	signupSource: string;  
	token: string;
	accessToken: string;
	setUser: (user: Authentication) => void;
	setUserStatus: (status: string) => void;
	clear: () => void;
};

const useUserStore = create<UserStore>()(
	persist(
		(set, get) => ({
			id: 0,
			email: '',
			name: '',
			userStatus: '',
			token: '',
			accessToken: '',
			signupSource: '',
			setUser: ({ id, email, token, name, userStatus, signupSource }: Authentication) => {
				const encodedCredentials = encodeBase64(`${email}:${token}`);
				const normalizedUserStatus = userStatus ?? '';
				const normalizedName = name ?? '';
				const normalizedSignupSource = signupSource ?? '';
				if (normalizedUserStatus === 'pending') {
					set({
						id,
						email,
						token,
						name: normalizedName,
						userStatus: normalizedUserStatus,
						signupSource: normalizedSignupSource,
					});
				} else {
					set({
						id,
						email,
						token,
						accessToken: encodedCredentials,
						name: normalizedName,
						userStatus: normalizedUserStatus,
						signupSource: normalizedSignupSource,
					});
				}

				if (id) {
					useUserIdStore.getState().setUserId(String(id));
				}
			},
			setUserStatus: (status: string) => {
				set({ userStatus: status });
			},
			clear: () =>
				set({
					id: 0,
					email: '',
					name: '',
					userStatus: '',
					token: '',
					accessToken: '',
					signupSource: '',
				}),
		}),
		{ name: Storages.USER }
	)
);

window.addEventListener('storage', event => {
	if (event.key === '@uticket:logout') {
		useUserStore.getState().clear();
		window.localStorage.removeItem('@uticket:logout');
		window.localStorage.removeItem('@uticket:event-cart');
		return;
	}
	if (event.key === Storages.USER && event.newValue) {
		try {
			const parsedValue = JSON.parse(event.newValue);
			const currentState = useUserStore.getState()
			const newState = parsedValue.state;
			if (!newState) return;
			
			const newUserStatus = newState.userStatus;
			const currentUserStatus = currentState.userStatus;
			
			if (
				currentUserStatus === 'otp_pending' &&
				newUserStatus === 'active' &&
				currentState.email &&
				currentState.token &&
				currentState.email === newState.email &&
				currentState.token === newState.token
			) {
				useUserStore.getState().setUser({
					id: newState.id || currentState.id,
					email: newState.email || currentState.email,
					name: newState.name || currentState.name,
					token: newState.token || currentState.token,
					userStatus: 'active',
					signupSource: newState.signupSource || currentState.signupSource,
				});
			}
		} catch (error) {
			// Ignora erros de parsing
		}
	}
});

export default useUserStore;
